import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
`;

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
`;

const TrainSkeletonLoader = ({ count = 6 }) => {
  return (
    <TrainContainer>
      {Array.from({ length: count }).map((_, index) => (
        <SkeletonItem key={index}>
          {/* Thumbnail placeholder */}
          <SkeletonThumbnail />
        </SkeletonItem>
      ))}
    </TrainContainer>
  );
};

export default TrainSkeletonLoader;

const TrainContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const SkeletonItem = styled.div`
  width: 100%;
  max-width: 358px;
  height: 400px;
  border-radius: 24px;
  position: relative;
  overflow: hidden;
  background: #000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
`;

const SkeletonThumbnail = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #1a1a1a 0px, #2a2a2a 40px, #1a1a1a 80px);
  background-size: 468px 100%;
  animation: ${shimmer} 1.5s infinite linear, ${pulse} 2s infinite ease-in-out;
  border-radius: 12px;
`;
